<template>
  <InputField label="Credit/Debit Card" :error="hasError" :error-message="validationMessage" :active="isFocused" :filled="!isEmpty">
    <div id="recurly-card-input-field-cc" />
  </InputField>
</template>
<script setup lang="ts">
import InputField from '@/components/shared/inputs/InputField.vue'

import { toRaw, ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useErrorsStore } from '@/store/ErrorsStore'
import { useRecurlyStore } from '@/store/RecurlyStore'

const recurlyStore = useRecurlyStore()
const { recurlyElements } = storeToRefs(recurlyStore)

const props = defineProps({
  styles: {
    type: Object,
    required: true
  }
})

const errorsStore = useErrorsStore()
const { find: findError } = errorsStore
const { errorType } = storeToRefs(errorsStore)

const attached = ref(false)
const isValid = ref(false)
const isEmpty = ref(true)
const isFocused = ref(false)

defineExpose({ isValid })

onMounted(() => {
  attachRecurly()
})

const transactionError = computed(() => {
  return errorType.value === 'transaction'
})

const validationError = computed(() => {
  return (findError('number') && !isValid.value) || (!isValid.value && !isEmpty.value)
})

const hasError = computed(() => {
  return validationError.value || transactionError.value
})

const validationMessage = computed(() => {
  return validationError.value ? 'Your card number is not valid' : undefined
})

const attachRecurly = () => {
  if (attached.value) {
    return false
  }

  const styles = {
    ...props.styles,
    placeholder: {
      content: 'Card Number',
      fontWeight: 'normal',
      color: (props.styles.placeholderColor || '#FFFFFF') + ' !important'
    }
  }

  const cardElement = toRaw(recurlyElements.value).CardNumberElement({
    style: styles
  })

  attached.value = true
  cardElement.attach('#recurly-card-input-field-cc')

  cardElement.on('change', ({ empty, valid }: { empty: boolean; valid: boolean }) => {
    isEmpty.value = empty
    isValid.value = valid
  })

  cardElement.on('focus', () => {
    isFocused.value = true
  })

  cardElement.on('blur', () => {
    isFocused.value = false
  })
}
</script>
